import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  select(event) {
    const clickedOption = event.currentTarget
    const pinId = clickedOption.dataset.pinId

    // Update hidden input value
    this.inputTarget.value = pinId

    // Remove selected class from all options
    this.element.querySelectorAll('.pin-option').forEach(option => {
      option.classList.remove('selected')
    })

    // Add selected class to clicked option
    clickedOption.classList.add('selected')
  }
}
